import {
  CustomizedSummaryDetails,
  type CustomizedSummaryDetailsProps,
} from './components/CustomizedSummaryDetails';
import { SimpleDetails, type SimpleDetailsProps } from './components/SimpleDetails';

type Props = SimpleDetailsProps | CustomizedSummaryDetailsProps;

export function Details(props: Props) {
  if (props.variant === 'simple') {
    return <SimpleDetails {...props} />;
  }
  return <CustomizedSummaryDetails {...props} />;
}
